import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Settings } from "../../utils/Settings";

interface StudentCardProps {
  student: any;
}

const StudentCard = ({ student }: StudentCardProps) => {
  const avatar = student.avatarUrl
    ? Settings.getFile(student.avatarUrl)
    : student.photo
    ? Settings.getFile(student.photo)
    : null;

  return (
    <Card className="h-100">
      <CardBody>
        <Row>
          <Col lg={4} className="avatar-wrapper text-center">
            {avatar ? (
              <img
                src={avatar}
                alt={student.name}
                className="rounded-circle"
                style={{ width: 80, height: 80, objectFit: "cover" }}
              />
            ) : (
              <div
                className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center text-muted"
                style={{ width: 80, height: 80 }}
              >
                <i className="fas fa-user fa-2x"></i>
              </div>
            )}
          </Col>
          <Col lg={8}>
            <p className="mb-1">
              <b>{student.name}</b>
            </p>
            <div className="text-muted small">
              {[student.studentid, [student.form, student.stream].filter(Boolean).join(" ")]
                .filter(Boolean)
                .join(" - ")}
            </div>
            {student.campus && (
              <div className="text-muted small mb-2">{student.campus}</div>
            )}
            {(student.balance !== undefined || student.attendance !== undefined) && (
              <p className="mb-2">
                <i className="fa fa-home me-1"></i>
                Attendance &nbsp;&nbsp;
                <i className="fa fa-check-square me-1"></i>
                {student.balance ?? "—"}
              </p>
            )}
            <div>
              <a href={`/students/${student.id}/results`}>Results</a>
              &nbsp;| <a href={`/students/${student.id}/financial`}>Financial</a>
              &nbsp;| <a href={`/students/${student.id}/attendance`}>Attendance</a>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default StudentCard;
